import React, { useEffect, useState, Fragment } from "react";
import Fade from "@material-ui/core/Fade";
import loadImage from "blueimp-load-image";
import CircularProgress from "@material-ui/core/CircularProgress";
import Firebase from "../../../firebasehelper";
import FileUpload from "../../../components/ContentUpload/FileUpload";
import DateTimePicker from "../../../components/DateTimePicker";
import { default_offer } from "../constants/default";
import {
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  GIF_UPLOAD,
} from "../../../Constants/types";
import {
  UPLOADING_VIDEO,
  UPLOADING_IMAGE,
  UPLOADING_GIF,
} from "../../../Constants/string";
import "./AddPerkModal.css";

const AddPerkModal = ({ onAdd, hex, white }) => {
  const [loading, setLoading] = useState(false);
  const [loading_script, setLoadingScript] = useState("");
  const [perk, setPerk] = useState(default_offer);
  const [isPostable, setIsPostable] = useState(false);
  useEffect(() => {
    if (perk.perkName && perk.perkLogo && perk.startTime && perk.endTime)
      setIsPostable(true);
    else setIsPostable(false);
  }, [perk]);
  const updatePerkName = ({ target }) => {
    perk.perkName = target.value;
    setPerk({ ...perk });
  };
  const uploadContent = (fieldName) => async (content) => {
    let uploadFolder = "perks";
    const title = perk.perkName || new Date().getTime().toString();
    setLoading(true);
    const { mediaType, mediaContent } = content;
    try {
      if (mediaType === GIF_UPLOAD || mediaType === IMAGE_UPLOAD) {
        setLoadingScript(
          mediaType === IMAGE_UPLOAD ? UPLOADING_IMAGE : UPLOADING_GIF
        );
        let media_url = await Firebase.uploadImage(
          mediaContent,
          title,
          uploadFolder + "/images"
        );
        setLoading(false);
        perk[fieldName] = media_url;
        perk[`${fieldName}_type`] = mediaType;
        setPerk({ ...perk });
      } else if (mediaType === VIDEO_UPLOAD) {
        const uploadTask = Firebase.uploadVideo(
          mediaContent,
          uploadFolder + "/videos"
        );
        uploadTask.on(
          "state_changed",
          handleUploadProgress,
          handleUploadError,
          () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              setLoading(false);
              setLoadingScript("");
              perk[fieldName] = downloadURL;
              perk[`${fieldName}_type`] = mediaType;
              setPerk({ ...perk });
            });
          }
        );
      }
    } catch (error) {
      setLoading(false);
      console.log("uploadContent() error", error);
    }
  };
  const handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    setLoadingScript(loading_script);
  };

  const handleUploadError = (_error) => {
    setLoadingScript("");
    setLoading(false);
  };
  const handleChangeStartTime = (time) => {
    perk.startTime = time;
    setPerk({ ...perk });
  };
  const handleChangeEndTime = (time) => {
    perk.endTime = time;
    setPerk({ ...perk });
  };
  const handleClickAdd = () => {
    perk.startTime = perk.startTime.valueOf();
    perk.endTime = perk.endTime.valueOf();
    onAdd(perk);
  };
  return (
    <div
      className="modal fade add-perk-modal"
      id="add_perk_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">List a perk offer</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1">
            <div
              style={{
                marginBottom: 10,
              }}
            >
              <h5 className="section-title">Offer title</h5>
              <input
                className="form-control form-control-md "
                name="retailerName"
                placeholder="Input insider perk name here..."
                onChange={updatePerkName}
              />
              <h5 className="section-title">Offer thumbnail</h5>
              <FileUpload onChangeContent={uploadContent("perkThumbnail")} />
              <h5 className="section-title">Promotion banner</h5>
              <FileUpload onChangeContent={uploadContent("perkBanner")} />
              <h5 className="section-title">Promotion Logo</h5>
              <FileUpload onChangeContent={uploadContent("perkLogo")} />
              <h5 className="section-title">From</h5>
              <DateTimePicker onTimeChange={handleChangeStartTime} />
              <h5 className="section-title">Until</h5>
              <DateTimePicker onTimeChange={handleChangeEndTime} />
            </div>
          </div>
          <Fade
            in={loading}
            style={{
              transitionDelay: loading ? "800ms" : "0ms",
            }}
            unmountOnExit
          >
            <Fragment>
              <p>{loading_script}</p>
              <CircularProgress />
            </Fragment>
          </Fade>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-brand-hex btn-white"
              style={{
                "--hover-text-color": white ? "white" : "black",
                "--hover-color": hex,
                backgroundColor: "white",
                color: "black",
              }}
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-green"
              data-dismiss="modal"
              disabled={!isPostable}
              onClick={handleClickAdd}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddPerkModal;



// WEBPACK FOOTER //
// ./src/screens/Perks/components/AddPerkModal.js